import React from 'react';
import { useNavigate } from 'react-router-dom';
import FNOLForm from './FNOLForm';
import DocumentViewer from './DocumentViewer';
import './DataHandlingPage.css';

const DataHandlingPage = ({
    isSplitScreen,
    inboxOpen,
    form,
    setF,
    isEditMode,
    loadingFNOL,
    isCompleted,
    handleEdit,
    handleComplete,
    handleCancel,
    handleSubmit,
    hasChanges,
    revalidating,
    documents,
    filteredDocuments,
    loadingDocuments,
    selectedDocId,
    setSelectedDocId,
    selectedDoc,
    documentSearchQuery,
    setDocumentSearchQuery,
    openPreview,
    inlinePreviewUrl,
    inlinePreviewLoading,
    setIsSplitScreen,
    setInboxOpen,
    onContinue,
    hasClaimId,
    originalEvidence,
    fnolId,
}) => {
    const navigate = useNavigate();

    return (
        <div className="row h-100 gx-2">
            <div
                className={`main-form-area ${isSplitScreen ? 'col-12 col-lg-6' : 'col-12 col-lg-8'} h-100 overflow-auto`}>
                <FNOLForm
                    form={form}
                    setF={setF}
                    isEditMode={isEditMode}
                    loadingFNOL={loadingFNOL}
                    isCompleted={isCompleted}
                    handleEdit={handleEdit}
                    handleComplete={handleComplete}
                    onContinue={onContinue}
                    handleCancel={handleCancel}
                    handleSubmit={handleSubmit}
                    hasChanges={hasChanges}
                    revalidating={revalidating}
                    hasClaimId={hasClaimId}
                    originalEvidence={originalEvidence}
                    fnolId={fnolId}
                    // Document Viewer Props
                    documents={documents}
                    filteredDocuments={filteredDocuments}
                    loadingDocuments={loadingDocuments}
                    selectedDocId={selectedDocId}
                    setSelectedDocId={setSelectedDocId}
                    selectedDoc={selectedDoc}
                    documentSearchQuery={documentSearchQuery}
                    onDocumentSearchChange={setDocumentSearchQuery}
                    onOpenPreview={openPreview}
                    inlinePreviewUrl={inlinePreviewUrl}
                    inlinePreviewLoading={inlinePreviewLoading}
                    isSplitScreen={isSplitScreen}
                    setIsSplitScreen={setIsSplitScreen}
                    inboxOpen={inboxOpen}
                    setInboxOpen={setInboxOpen}
                />
            </div>

            <DocumentViewer
                documents={documents}
                filteredDocuments={filteredDocuments}
                loadingDocuments={loadingDocuments}
                selectedDocId={selectedDocId}
                setSelectedDocId={setSelectedDocId}
                selectedDoc={selectedDoc}
                documentSearchQuery={documentSearchQuery}
                onDocumentSearchChange={setDocumentSearchQuery}
                onOpenPreview={openPreview}
                inlinePreviewUrl={inlinePreviewUrl}
                inlinePreviewLoading={inlinePreviewLoading}
                isSplitScreen={isSplitScreen}
                setIsSplitScreen={setIsSplitScreen}
                inboxOpen={inboxOpen}
                setInboxOpen={setInboxOpen}
                className="d-none d-lg-block"
            />
        </div>
    );
};

export default DataHandlingPage;
